import React from 'react';

const UnAuthorized = () => (
  <div style={styles.container}>
    <h2 style={styles.title}>Unauthorized Access</h2>
    <p style={styles.message}>
      You are not authorized to access this page.<br />
      Please contact your administrator if you believe this is an error.
    </p>
  </div>
);

const styles = {
  container: {
    maxWidth: '500px',
    margin: '80px auto',
    padding: '32px',
    background: '#fff6f6',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(192,57,43,0.10)',
    textAlign: 'center',
  },
  title: {
    color: '#c0392b',
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '18px',
  },
  message: {
    color: '#555',
    fontSize: '1.15rem',
    marginTop: '12px',
    lineHeight: '1.6',
  },
};

export default UnAuthorized;